import { message } from 'antd';
import { putWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const updateHourRateForMonth = async (data: any, refetch?: () => void) => {
  console.log('Updating hourRate with: ', data);
  try {
    const response = await putWithCSRF(`${envApiUrl}/registrations/updateHourRate`, data);
    console.log('updateHourRateForMonth response: ', response);
    message.success('Successfully updated hourRates');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('updateHourRateForMonth error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || 'Failed to update hourRates');
  }
};
